import { createIcon } from '@chakra-ui/icons';

export const Facebook = createIcon({
  displayName: 'Facebook',
  viewBox: '0 0 13 24',
  d: 'M8.4 13.8H11.4L12.6 9H8.4V6.6C8.4 5.364 8.4 4.2 10.8 4.2H12.6V0.168C12.2088 0.1164 10.7316 0 9.1716 0C5.9136 0 3.6 1.9884 3.6 5.64V9H0V13.8H3.6V24H8.4V13.8Z',
});
